import GenericContact from '@/types/generic-contact';
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import { PrimaryButton } from '@/views/components/buttons';
import { ActionBox } from '@/views/components/misc';
import React, { FC } from 'react';

type Props = {
  contact?: GenericContact;
  completeKycQuestionnaire: () => void;
};

const SkipActionBox: FC<Props> = ({ contact, completeKycQuestionnaire }) => {
  let title = formatMessage('CreateRiskProfile.SkipRiskProfile.GenericTitle');
  if (contact) {
    title = formatMessage('CreateRiskProfile.SkipRiskProfile.Title', { name: contact.fname || contact.email || '' });
  }

  return (
    <ActionBox title={title} body={formatMessage('CreateRiskProfile.SkipRiskProfile.Text')} data-private data-dd-privacy="mask">
      <PrimaryButton onClick={completeKycQuestionnaire}>
        <FormattedMessage id="Common.Skip" />
      </PrimaryButton>
    </ActionBox>
  );
};

export default SkipActionBox;
